module.exports = __webpack_public_path__ + "img/AI.94393762.svg";